<template>
  <div class="el-col-24 role-add-css" v-loading="isDetailLoading">
    <h5 class="warp-title">{{mTitle}}角色</h5>
    <div class="search-type mb15">
      <p class="p-title">角色名称</p>
      <el-input
        v-model.trim="input"
        size="small"
        maxlength="20"
        clearable>
      </el-input>
      <el-button size="small" type="primary" class="btn-save" @click="submit" :loading="isSubmitLoading">全部保存</el-button>
    </div>
    <p class="p-title">备注</p>
    <el-input
      type="textarea"
      :rows="4"
      v-model.trim="input2"
      size="small"
      maxlength="50"
      clearable>
    </el-input>
    <div>
      <!-- <p class="p-title">权限</p> -->
      <el-tabs v-model="mTabState" @tab-click="handleClick">
        <el-tab-pane label="操作权限" name="first"></el-tab-pane>
        <el-tab-pane label="数据权限" name="second"></el-tab-pane>
      </el-tabs>
      <div v-show="mTabState === 'first'">
        <div v-if="kfData.length > 0" class="mb20">
          <el-button size="mini" type="danger" @click="handleTreeExpandStatus(false)">全部收起</el-button>
          <el-button size="mini" type="primary" @click="handleTreeExpandStatus(true)">全部展开</el-button>
        </div>
        <el-tree
          :data="kfData"
          show-checkbox
          :key="treeRefreshKey"
          node-key="id"
          ref="tree"
          highlight-current
          @check="handleNodeClick"
          :default-checked-keys="checkedSub"
          :props="defaultProps"
          :default-expand-all="isTreeExpand"
          class="role-tree-container">
        </el-tree>
      </div>
      <div class="r-b" v-show="mTabState === 'second'">
        <dl>
          <dt>客服统计数据查看</dt>
          <dd>
            <el-radio-group v-model="radio3">
              <el-radio :label="1">当前客服统计数据查看</el-radio>
              <el-radio :label="2">全部客服统计数据查看</el-radio>
            </el-radio-group>
          </dd>
        </dl>
        <dl>
          <dt>工单数据查看</dt>
          <dd>
            <el-radio-group v-model="radio1">
              <el-radio :label="1">查看自己跟进部分用户数据</el-radio>
              <el-radio :label="0">查看全部用户数据</el-radio>
            </el-radio-group>
          </dd>
        </dl>
        <dl v-if="radio1 === 1">
          <dt>自己生成的工单，即使分配到其他客服，本人是否可见</dt>
          <dd>
            <el-radio-group v-model="radio2">
              <el-radio :label="0">是</el-radio>
              <el-radio :label="1">否</el-radio>
            </el-radio-group>
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
import { queryRolePermission, addRole, editRoleReturn, editRole } from '../../../api/power/role'
export default {
  name: 'RoleAdd',
  created () {
  },
  data () {
    return {
      isDetailLoading: false,
      isTreeExpand: false,
      isSubmitLoading: false,
      mState: this.$route.query.state,
      mId: this.$route.query.id || 0,
      defaultProps: {
        children: 'children',
        label: 'permissionName'
      },
      mTitle: '新增',
      input: '',
      input2: '',
      radio1: 0,
      radio2: 0,
      radio3: 2,
      mTabState: 'first',
      checkAll: false,
      checkedSub: [],
      kfData: [],
      halfAndCheck: [],
      treeRefreshKey: Date.now()
    }
  },
  methods: {
    // 展开/收起全部
    handleTreeExpandStatus (value) {
      this.isTreeExpand = value
      this.treeRefreshKey = Date.now()
    },
    handleClick (tab, event) {
      // console.log(tab, event)
    },
    handleNodeClick (node, data) {
      this.checkedSub = data.checkedKeys
      this.halfAndCheck = [...data.halfCheckedKeys, ...data.checkedKeys]
    },
    submit () {
      if (!this.input) {
        this.$message.warning('请输入角色名称')
        return false
      }
      let params = {
        roleName: this.input,
        dataView: this.radio1,
        permissionIdList: this.halfAndCheck,
        remark: this.input2,
        customerStatisticalVisible: this.radio3
      }
      if (this.radio1 === 1) {
        params.workerVisible = this.radio2
      }
      this.isSubmitLoading = true
      if (this.mState) {
        params.id = this.mId
        editRole(params).then(res => {
          this.isSubmitLoading = false
          let data = res.data
          if (data.resultCode === 0) {
            this.$message.success(data.resultMessage)
            this.$message.success('编辑成功')
            this.$store.commit('delTab', this.$route)
            this.$router.push({name: 'Role', query: {refresh: Date.now()}})
          } else {
            this.$message.error(data.resultMessage)
          }
        }).catch(() => {
          this.isSubmitLoading = false
        })
      } else {
        addRole(params).then(res => {
          this.isSubmitLoading = false
          let data = res.data
          if (data.resultCode === 0) {
            this.$message.success(data.resultMessage)
            this.$message.success('新增成功')
            this.$store.commit('delTab', this.$route)
            this.$router.push({name: 'Role', query: {refresh: Date.now()}})
          } else {
            this.$message.error(data.resultMessage)
          }
        }).catch(() => {
          this.isSubmitLoading = false
        })
      }
    },
    initData () {
      let param = {
        roleId: this.mId
      }
      this.isDetailLoading = true
      queryRolePermission(param).then(res => {
        let data = res.data
        if (data.resultCode === 0) {
          let resultData = data.resultData
          this.kfData = resultData
        }
      }).finally(() => {
        this.isDetailLoading = false
      })
    },
    checkId (list) {
      for (let i = 0; i < list.length; i++) {
        if (list[i].children) {
          this.checkId(list[i].children)
        } else {
          if (list[i].status === 0) {
            this.checkedSub.push(list[i].id)
          }
        }
      }
    }
  },
  mounted () {
    if (this.mState) {
      this.mTitle = '编辑'
      let param = {
        roleId: this.mId
      }
      this.isDetailLoading = true
      editRoleReturn(param).then(res => {
        let data = res.data
        if (data.resultCode === 0) {
          let resultData = data.resultData
          let datas = resultData.customerRolePriInfoRespDTO
          this.kfData = resultData.customerRolePriRespDTO
          this.input = datas.roleName
          this.input2 = datas.remark
          this.radio1 = datas.dataView
          this.radio2 = datas.workerVisible
          this.radio3 = datas.customerStatisticalVisible
          this.checkId(resultData.customerRolePriRespDTO)
          this.$nextTick(() => {
            this.halfAndCheck = [...this.$refs.tree.getHalfCheckedKeys(), ...this.$refs.tree.getCheckedKeys()]
          })
        }
      }).finally(() => {
        this.isDetailLoading = false
      })
    } else {
      this.initData()
    }
  }
}
</script>
<style lang="less" scoped>
/deep/.el-tree-node__content{
  height: 32px;
}
/deep/.el-tree-node__label{
  font-size: 16px;
}
.p-title{
  font-weight: 600;
  font-size: 18px;
  color: #666;
  margin: 10px 0;
}
.search-type{
  // width: 300px;
  .btn-save{
    margin-left: 30px;
  }
}
.r-b{
  dl{
    margin: 15px 0;
    dt{
      margin: 15px 0;
      font-size: 16px;
    }
  }
}
/deep/.role-tree-container{
  .el-tree-node__content{
    height: 32px;
    .el-tree-node__label{
      font-size: 16px;
      margin-left: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Power/Role/Add.vue